<template>
  <FontAwesomeIcon
    v-if="props.source === 'fortawesome'"
    v-bind="$attrs"
    :icon="computedIcon"
  />
  <component v-else :is="customIcon" v-bind="$attrs" />
</template>

<script setup>
import { computed, defineAsyncComponent } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import ReservationIcon from "./icons/ReservationIcon.vue";

const props = defineProps({
  source: {
    type: String,
    default: "fortawesome",
  },
  icon: {
    type: [String, Array],
    require: true,
  },
});

const computedIcon = computed(() => {
  if (Array.isArray(props.icon)) {
    return props.icon;
  } else if (props.icon.startsWith("fab")) {
    return props.icon.split(",");
  } else {
    return props.icon;
  }
});

const customIcon = computed(() => {
  if (props.source !== "fortawesome") {
    return defineAsyncComponent(
      () => import(`@/components/GlobalComponents/icons/${props.icon}.vue`)
    );
  } else {
    return null;
  }
});
</script>
